import type { IdTokenData } from '@/features/auth/types/idTokenSchema'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { UserState } from '../slices/userSlice'

const setData = (state: UserState, action: PayloadAction<IdTokenData>) => {
  state.userName = action.payload.name
  state.userId = action.payload.sub
}

const setRoles = (state: UserState, action: PayloadAction<Array<string>>) => {
  state.roles = action.payload
}

const setOriginalUser = (state: UserState, action: PayloadAction<UserState>) => {
  state.originalUser = {
    userId: action.payload.userId,
    userName: action.payload.userName,
  }
}

const deleteOriginalUser = (state: UserState) => {
  state.originalUser = undefined
}

export { setData, setRoles, setOriginalUser, deleteOriginalUser }
